module.exports = __webpack_public_path__ + "img/assoc_user_company.862a0b10.png";